import React, { useState } from 'react';
import './CalculatorPage.css';

function PersonalYearNumberCalculator() {
  const [birthDate, setBirthDate] = useState('');
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear().toString());
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (bDate, cYear) => {
    // Personal Year Number calculation logic
    // Sum of birth month + birth day + current year, reduced to a single digit
    const dobParts = bDate.split('/');
    if (dobParts.length !== 3) return null;

    const month = parseInt(dobParts[1], 10);
    const day = parseInt(dobParts[0], 10);
    const year = parseInt(cYear, 10);

    if (isNaN(month) || isNaN(day) || isNaN(year) || month < 1 || month > 12 || day < 1 || day > 31) {
      return null;
    }

    let sum = month + day + year;

    while (sum > 9 && sum !== 11 && sum !== 22) { // Master numbers 11, 22 are not reduced
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(birthDate)) {
      setError('Please enter a valid birth date in DD/MM/YYYY format.');
      return;
    }
    if (isNaN(parseInt(currentYear, 10)) || currentYear.length !== 4) {
      setError('Please enter a valid 4-digit current year.');
      return;
    }

    const calculated = calculate(birthDate, currentYear);
    if (calculated === null) {
      setError('Invalid input. Please check your birth date or current year.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (num) => {
    return `Personal Year Number ${num}: This is a placeholder explanation for Personal Year Number ${num}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Personal Year Number Calculator",
    "description": "Calculate your Personal Year Number and understand the themes and energies for your current year.",
    "url": "https://www.yourwebsite.com/personal-year-number-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Personal Year Number",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/personal-year-number-calculator?birthDate={birthDate}&currentYear={currentYear}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": [
        "required name=birthDate",
        "required name=currentYear"
      ]
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Personal Year Number Calculator</h1>
      <p className="text-center">Discover the numerological themes for your current year.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="birthDate">Your Birth Date (DD/MM/YYYY):</label>
          <input
            type="text"
            id="birthDate"
            className="form-control"
            value={birthDate}
            onChange={(e) => setBirthDate(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        <div className="form-group">
          <label htmlFor="currentYear">Current Year:</label>
          <input
            type="text"
            id="currentYear"
            className="form-control"
            value={currentYear}
            onChange={(e) => setCurrentYear(e.target.value)}
            placeholder="e.g., 2024"
            maxLength="4"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Calculate Personal Year Number</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Personal Year Number is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default PersonalYearNumberCalculator;
